import { render, staticRenderFns } from "./writ.vue?vue&type=template&id=506d8f04&scoped=true"
import script from "./writ.vue?vue&type=script&lang=js"
export * from "./writ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506d8f04",
  null
  
)

export default component.exports